import { Container } from 'inversify-props';
import setupGoalsDashboardProgressStatus from './progress/setup';
import setupGoalsDashboardDistribute from './distribute-balance/setup';

export default function setupGoalsDashboardModule(container: Container) {
  setupGoalsDashboardProgressStatus(container);
  setupGoalsDashboardDistribute(container);
}
